import { getContext } from '@picsart/miniapps-sdk';
import { TaskError, defaultConfig, ReqError, APP_API_URL } from '../constants';
import { Task } from '../types';
import { NetworkError } from './errors/networkError';
import { PromptError } from './errors/promptError';
import { NsfwError } from './errors/nsfwError';

async function requestTextToBG(text: string, count = 3, pageConfig: any, serviceConfig: any): Promise<Task> {
  const { task_type, t2b_service_url: T2BServiceURL, t2b_ai_service_path: T2BAIServicePath, negative_prompt: negativePrompt } = serviceConfig;

  return getContext()
    .utils.api.fetch(`${APP_API_URL}${T2BServiceURL}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        platform: 'web',
        aiBaseServiceUrl: T2BAIServicePath,
      },
      body: JSON.stringify({
        caption: text,
        styles: [],
        batch_size: count,
        task_type,
        size: '1024x1024',
        negative_prompt: negativePrompt,
      }),
    })
    .then(res => Promise.all([res, res.json()]))
    .then(([res, body]) => {
      if (!res.ok) {
        const {
          errors: { service_error: serverError },
        } = defaultConfig;

        const {
          character_limitation: { text: characterLimitationError },
          restriction_config: { text: restrictionText, action_title, action },
        } = pageConfig;

        if (body.status === TaskError.FORBIDDEN_TEXT || body.message === ReqError.FORBIDDEN_TEXT) {
          const forbiddenText = restrictionText.replace(/%a/g, `<a href="${action}" target="_blank">${action_title}</a>`);
          throw new NsfwError(forbiddenText);
        }

        if (body.status === TaskError.INVALID_CAPTION) {
          throw new PromptError(characterLimitationError);
        }

        throw new NetworkError(serverError);
      }

      return body.response;
    });
}

export default requestTextToBG;
